import {useNotification} from '@hconnect/uikit/src/common'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {SAMPLING_POINTS_QUERY_KEY} from '../../api/queries/getSamplingPoints'

import {mutations} from '@settings/api/mutations'
import {invalidateSettingsQuery} from '@settings/modules/common/providers'
import {ErrorResponse} from '@settings/modules/common/types'
import {notifyIfErrorMessage} from '@settings/modules/common/utils'

type deleteSamplingPointParams = Parameters<typeof mutations.deleteSamplingPoint>[0]

export function useDeleteSamplingPointMutation() {
  const {notify} = useNotification()
  const raiseError = useErrorHandler()
  const {t} = useTranslation()

  return useMutation<void, AxiosError<ErrorResponse>, deleteSamplingPointParams>({
    mutationFn: mutations.deleteSamplingPoint,
    onSuccess: (_, variables) => {
      notify('success', t('samplingPointsSettings.editSamplingPointSuccess'))
      invalidateSettingsQuery(SAMPLING_POINTS_QUERY_KEY, variables.plantCode)
    },
    onError: (error) => {
      const errorDetails = error?.response?.data.detail ?? error.message ?? error.response?.status
      notifyIfErrorMessage(
        t('samplingPointsSettings.mutations.deleteSamplingPointError', {
          details: errorDetails
        }),
        raiseError,
        notify
      )
    }
  })
}
